// app/ThemeRegistry.tsx
"use client";

import { c as _c } from "react/compiler-runtime";
import createCache from "@emotion/cache";
import { useServerInsertedHTML } from "next/navigation";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import theme from "../../lib/utils/theme";
import { useState } from "react";

// This implementation is from emotion-js
// https://github.com/emotion-js/emotion/issues/2928#issuecomment-1319747902
export default function ThemeRegistry(props) {
  const $ = _c(10);
  const {
    options,
    children
  } = props;
  let t0;
  if ($[0] !== options) {
    t0 = () => {
      const cache = createCache(options);
      cache.compat = true;
      const prevInsert = cache.insert;
      let inserted = [];
      cache.insert = (...t1) => {
        const args = t1;
        const serialized = args[1];
        if (cache.inserted[serialized.name] === undefined) {
          inserted.push(serialized.name);
        }
        return prevInsert(...args);
      };
      const flush = () => {
        const prevInserted = inserted;
        inserted = [];
        return prevInserted;
      };
      return {
        cache,
        flush
      };
    };
    $[0] = options;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [t1] = useState(t0);
  const {
    cache: cache_0,
    flush: flush_0
  } = t1;
  let t2;
  if ($[2] !== cache_0 || $[3] !== flush_0) {
    t2 = () => {
      const names = flush_0();
      if (names.length === 0) {
        return null;
      }
      let styles = "";
      for (const name of names) {
        styles = styles + cache_0.inserted[name];
      }
      return <style key={cache_0.key} data-emotion={`${cache_0.key} ${names.join(" ")}`} dangerouslySetInnerHTML={{
        __html: styles
      }} />;
    };
    $[2] = cache_0;
    $[3] = flush_0;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useServerInsertedHTML(t2);
  let t3;
  if ($[5] !== children) {
    t3 = <ThemeProvider theme={theme}>{children}</ThemeProvider>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== cache_0 || $[8] !== t3) {
    t4 = <CacheProvider value={cache_0}>{t3}</CacheProvider>;
    $[7] = cache_0;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}